import { Helmet } from 'react-helmet';
import localizations from '../localizations';
import useLocale from '../Hooks/use-locale';
import DkConvertTag from './dk-convert-tag';
import UkConvertTag from './uk-convert-tag';
import ItalianGoogleTag from './it-google-tag';
import AuConvertTag from './au-convert-tag';
import UsConvertTag from './us-convert-tag';
import DeConvertTag from './de-convert-tag';
import { shopIds } from '../shop-ids';

interface PageMetadataProps {
  shopName: string | undefined;
  shopId: string | undefined;
  shopCountry: string | undefined;
  children?: React.ReactNode;
}

const PageMetadata = (props: PageMetadataProps) => {
  const { languageAsEnum } = useLocale();
  const localization = localizations[languageAsEnum];

  return (
    <>
      <Helmet titleTemplate="GoBoat Booking - %s">
        {props.shopName && <title>{props.shopName}</title>}
        {localization.meta.description && (
          <meta name="description" content={localization.meta.description} />
        )}
        {props.shopId && props.shopId === shopIds.MALMO && (
          <meta name="robots" content="noindex" />
        )}
        {props.children}
      </Helmet>

      <AuConvertTag shopCountry={props.shopCountry} />
      <DkConvertTag shopCountry={props.shopCountry} />
      <UkConvertTag shopCountry={props.shopCountry} />
      <UsConvertTag shopCountry={props.shopCountry} />
      <DeConvertTag shopCountry={props.shopCountry} />
      <ItalianGoogleTag shopCountry={props.shopCountry} />
    </>
  );
};

export default PageMetadata;
